import { actionCreator } from 'utils';
import * as DesignLibraryTypes from '../types/designLibraryTypes';

// L O A D   D E S I G N   L I B R A R Y   L I S T
export function loadDesignLibraryList() {
    return {
        type: DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST,
    };
}

export function loadDesignLibraryListRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST, 'res'),
        data,
    };
}

export function loadDesignLibraryListErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_LIST, 'err'),
    };
}
// L O A D   D E S I G N   L I B R A R Y   L I S T

// S E T   D E S I G N   L I B R A R Y   F I L T E R S
export function setDesignLibraryFilters(key, value) {
    return {
        type: DesignLibraryTypes.SET_DESIGN_LIBRARY_FILTERS,
        key,
        value,
    };
}
// S E T   D E S I G N   L I B R A R Y   F I L T E R S

// R E S E T   D E S I G N   L I B R A R Y   F I L T E R S
export function resetDesignLibraryFilters() {
    return {
        type: DesignLibraryTypes.RESET_DESIGN_LIBRARY_FILTERS,
    };
}

export function resetDesignLibraryFiltersRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.RESET_DESIGN_LIBRARY_FILTERS, 'res'),
        data,
    };
}
// R E S E T   D E S I G N   L I B R A R Y   F I L T E R S

// S E T   D E S I G N   L I B R A R Y   P A G I N A T I O N
export function setDesignLibraryPagination(key, pagination) {
    return {
        type: DesignLibraryTypes.SET_DESIGN_LIBRARY_PAGINATION,
        key,
        pagination,
    };
}
// S E T   D E S I G N   L I B R A R Y   P A G I N A T I O N

// S E T   D E S I G N   L I B R A R Y   S O R T
export function setDesignLibrarySort(key, type) {
    return {
        type: DesignLibraryTypes.SET_DESIGN_LIBRARY_SORT,
        sort: {
            key,
            type,
        },
    };
}
// S E T   D E S I G N   L I B R A R Y   S O R T

// S E T   C H E C K E D   L I B R A R Y
export function setCheckedDesignLibraryItem(ids) {
    return {
        type: DesignLibraryTypes.SET_CHECKED_LIBRARYS,
        ids,
    };
}
// S E T   C H E C K E D   L I B R A R Y

// R E S E T   C H E C K E D   L I B R A R Y
export function resetDesignLibraryChecked() {
    return {
        type: DesignLibraryTypes.RESET_DESIGN_LIBRARY_CHECKED,
    };
}

export function resetDesignLibraryCheckedRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.RESET_DESIGN_LIBRARY_CHECKED, 'res'),
        data,
    };
}
// R E S E T   C H E C K E D   L I B R A R Y

// T O G G L E   D E S I G N   L I B R A R Y   I T E M   S T A T E
export function toggleDesignLibraryItemState(data) {
    return {
        type: DesignLibraryTypes.TOGGLE_DESIGN_LIBRARY_ITEM_STATE,
        data,
    };
}
// T O G G L E   D E S I G N   L I B R A R Y   I T E M   S T A T E

// C L E A R   V I E W   D E S I G N   L I S T I N G
export function clearViewDesignListing() {
    return {
        type: DesignLibraryTypes.CLEAR_VIEW_DESIGN_LISTING,
    };
}
// C L E A R   V I E W   D E S I G N   L I S T I N G

// L O A D   D E S I G N   L I B R A R Y   S E T T I N G S
export function loadDesignLibrarySettings() {
    return {
        type: DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS,
    };
}

export function loadDesignLibrarySettingsRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS, 'res'),
        data,
    };
}

export function loadDesignLibrarySettingsErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_DESIGN_LIBRARY_SETTINGS, 'err'),
    };
}
// L O A D   D E S I G N   L I B R A R Y   S E T T I N G S

// A D D   N E W   D E S I G N   L I B R A R Y   S E T T I N G S
export function addDesignLibrarySettings(data) {
    return {
        type: DesignLibraryTypes.ADD_DESIGN_LIBRARY_SETTINGS,
        data,
    };
}
// A D D   N E W   D E S I G N   L I B R A R Y   S E T T I N G S

// S E T   S E L E C T E D   T H E M E
export function setSelectedThemeId(data) {
    return {
        type: DesignLibraryTypes.SET_SELECTED_THEME_ID,
        data,
    };
}
// S E T   S E L E C T E D   T H E M E

// S E T   E D I T A B L E   S E T T I N G   I D
export function setEditableSettingId(data) {
    return {
        type: DesignLibraryTypes.SET_EDITABLE_SETTING_ID,
        data,
    };
}
// S E T   E D I T A B L E   S E T T I N G   I D

// S E T   E D I T I N G   S E T T I N G   V A L U E
export function setEditingSettingValue(data) {
    return {
        type: DesignLibraryTypes.SET_EDITING_SETTING_VALUE,
        data,
    };
}
// S E T   E D I T I N G   S E T T I N G   V A L U E

// E D I T   N E W   D E S I G N   L I B R A R Y   S E T T I N G S
export function editDesignLibrarySettings(data) {
    return {
        type: DesignLibraryTypes.EDIT_DESIGN_LIBRARY_SETTINGS,
        data,
    };
}
// E D I T   N E W   D E S I G N   L I B R A R Y   S E T T I N G S

// D E L E T E   N E W   D E S I G N   L I B R A R Y   S E T T I N G S
export function deleteDesignLibrarySettings(data) {
    return {
        type: DesignLibraryTypes.DELETE_DESIGN_LIBRARY_SETTINGS,
        data,
    };
}

export function deleteDesignLibrarySettingsErr() {
    return {
        type: actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY_SETTINGS, 'res'),
    };
}
// D E L E T E   N E W   D E S I G N   L I B R A R Y   S E T T I N G S


// L O A D   L I B R A R Y   L I S T
export function loadLibrary(libraryID) {
    return {
        type: DesignLibraryTypes.LOAD_LIBRARY_LIST,
        libraryID,
    };
}

export function loadLibraryRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_LIBRARY_LIST, 'res'),
        data,
    };
}

export function loadLibraryErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_LIBRARY_LIST, 'err'),
    };
}
// L O A D    L I B R A R Y   L I S T

// L O A D   E D I T A B L E   D E S I G N   L I B R A R Y  F O R   D E S I G N
export function loadEditableDesignLibraryForDesign(id) {
    return {
        type: DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN,
        id,
    };
}

export function loadEditableDesignLibraryForDesignRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN, 'res'),
        data,
    };
}

export function loadEditableDesignLibraryForDesignErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITABLE_DESIGN_LIBRARY_FOR_DESIGN, 'err'),
    };
}
// L O A D   E D I T A B L E   D E S I G N   L I B R A R Y  F O R   D E S I G N

// A D D   N E W   D E S I G N   L I B R A R Y
export function addDesignLibrary(data) {
    return {
        type: DesignLibraryTypes.ADD_DESIGN_LIBRARY,
        data,
    };
}

export function addDesignLibraryRes(loading) {
    return {
        type: actionCreator(DesignLibraryTypes.ADD_DESIGN_LIBRARY, 'res'),
        loading,
    };
}

export function addDesignLibraryErr(error) {
    return {
        type: actionCreator(DesignLibraryTypes.ADD_DESIGN_LIBRARY, 'err'),
        error,
    };
}

export function goToStepOfDesignForm(step, propertyID) {
    return {
        type: DesignLibraryTypes.GO_TO_STEP_OF_DESIGN_FORM,
        step,
        propertyID,
    };
}
// A D D   N E W   D E S I G N   L I B R A R Y

// S E T   S E L E C T E D   D E S I G N
export function setSelectedDesign(selected) {
    return {
        type: DesignLibraryTypes.SET_SELECTED_DESIGN,
        selected,
    };
}
// S E T   S E L E C T E D   D E S I G N

// S E T   E D I T A B L E   D E S I G N   V A R I A N T
export function setEditableDesignVariant(data) {
    return {
        type: DesignLibraryTypes.SET_EDITABLE_DESIGN_VARIANT,
        data,
    };
}
// S E T   E D I T A B L E   D E S I G N   V A R I A N T

// S E T   E D I T A B L E  F I L E   I M A G E   T O  D E S I G N   V A R I A N T
export function setEditableImageFileToDesignVariant(data) {
    return {
        type: DesignLibraryTypes.SET_EDITABLE_IMAGE_FILE_DESIGN_VARIANT,
        data,
    };
}
// S E T   E D I T A B L E  F I L E   I M A G E   T O  D E S I G N   V A R I A N T

// L O A D   E D I T A B L E   D E S I G N   L I B R A R Y
export function loadEdiTableDesignLibrary(id) {
    return {
        type: DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY,
        id,
    };
}

export function loadEdiTableDesignLibraryRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY, 'res'),
        data,
    };
}

export function loadEdiTableDesignLibraryErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_LIBRARY, 'err'),
    };
}

export function setEmptyEdiTableDesignLibrary() {
    return {
        type: DesignLibraryTypes.SET_EMPTY_EDITTABLE_DESIGN_LIBRARY,
    };
}
// L O A D   E D I T A B L E   D E S I G N   L I B R A R Y

// E D I T   D E S I G N   L I B R A R Y
export function editDesignLibrary(data) {
    return {
        type: DesignLibraryTypes.EDIT_DESIGN_LIBRARY,
        data,
    };
}

export function editDesignLibraryRes(loading, success) {
    return {
        type: actionCreator(DesignLibraryTypes.EDIT_DESIGN_LIBRARY, 'res'),
        loading,
        success,
    };
}

export function editDesignLibraryErr() {
    return {
        type: actionCreator(DesignLibraryTypes.EDIT_DESIGN_LIBRARY, 'err'),
    };
}
// E D I T   D E S I G N   L I B R A R Y

// A D D   N E W   D E S I G N   V A R I A N T
export function addDesignVariant(data) {
    return {
        type: DesignLibraryTypes.ADD_DESIGN_VARIANT,
        data,
    };
}

export function addDesignVariantRes(success) {
    return {
        type: actionCreator(DesignLibraryTypes.ADD_DESIGN_VARIANT, 'res'),
        success,
    };
}

export function addDesignVariantErr(error) {
    return {
        type: actionCreator(DesignLibraryTypes.ADD_DESIGN_VARIANT, 'err'),
        error,
    };
}

// U P D A T E   T R A N S L A T E   P R O P R I E T Y
export function updateTranslateDesignLibrary() {
    return {
        type: DesignLibraryTypes.UPDATE_TRANSLATE_DESIGN_VARIANT,
    };
}

export function updateTranslateDesignLibraryRes(key, loading, success) {
    return {
        type: actionCreator(DesignLibraryTypes.UPDATE_TRANSLATE_DESIGN_VARIANT, 'res'),
        key,
        loading,
        success,
    };
}
// U P D A T E   T R A N S L A T E   P R O P R I E T Y

export function setDesignVariantPagination(key, pagination) {
    return {
        type: DesignLibraryTypes.SET_DESIGN_VARIANT_PAGINATION,
        key,
        pagination,
    };
}

// L O A D   E D I T A B L E   D E S I G N   V A R I A N T
export function loadEdiTableDesignVariant(id) {
    return {
        type: DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT,
        id,
    };
}

export function loadEdiTableDesignVariantRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT, 'res'),
        data,
    };
}

export function loadEdiTableDesignVariantErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_EDITTABLE_DESIGN_VARIANT, 'err'),
    };
}

export function setEmptyEdiTableDesignVariant() {
    return {
        type: DesignLibraryTypes.SET_EMPTY_EDITTABLE_DESIGN_VARIANT,
    };
}
// L O A D   E D I T A B L E   D E S I G N   V A R I A N T

// E D I T   D E S I G N   V A R I A N T
export function editDesignVariant(data) {
    return {
        type: DesignLibraryTypes.EDIT_DESIGN_VARIANT,
        data,
    };
}

export function editDesignVariantRes(loading, success) {
    return {
        type: actionCreator(DesignLibraryTypes.EDIT_DESIGN_VARIANT, 'res'),
        loading,
        success,
    };
}

export function editDesignVariantErr() {
    return {
        type: actionCreator(DesignLibraryTypes.EDIT_DESIGN_VARIANT, 'err'),
    };
}
// E D I T   D E S I G N   V A R I A N T


// L O A D   V I E W   D E S I G N   L I B R A R Y
export function loadViewDesignLibrary(id) {
    return {
        type: DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY,
        id,
    };
}
export function loadViewDesignLibraryRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY, 'res'),
        data,
    };
}
export function loadViewDesignLibraryErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_VIEW_DESIGN_LIBRARY, 'err'),
    };
}
// L O A D   V I E W   D E S I G N   L I B R A R Y

// D E L E T E   D E S I G N   L I B R A R Y
export function deleteDesignLibrary(data) {
    return {
        type: DesignLibraryTypes.DELETE_DESIGN_LIBRARY,
        data,
    };
}

export function deleteDesignLibraryRes(success) {
    return {
        type: actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY, 'res'),
        success,
    };
}

export function deleteDesignLibraryErr(error) {
    return {
        type: actionCreator(DesignLibraryTypes.DELETE_DESIGN_LIBRARY, 'err'),
        error,
    };
}
// D E L E T E   D E S I G N   L I B R A R Y

// D E L E T E   D E S I G N   V A R I A N T
export function deleteDesignVariant(data) {
    return {
        type: DesignLibraryTypes.DELETE_DESIGN_VARIANT,
        data,
    };
}

export function deleteDesignVariantRes(success) {
    return {
        type: actionCreator(DesignLibraryTypes.DELETE_DESIGN_VARIANT, 'res'),
        success,
    };
}


export function deleteDesignVariantErr(error) {
    return {
        type: actionCreator(DesignLibraryTypes.DELETE_DESIGN_VARIANT, 'err'),
        error,
    };
}
// D E L E T E   D E S I G N   V A R I A N T


// S E T   D E S I G N   V A R I A N T   I D
export function setDesignVariantId(id) {
    return {
        type: DesignLibraryTypes.SET_DESIGN_VARIANT_ID,
        id,
    };
}
// S E T   D E S I G N   V A R I A N T   I D

// L O A D   F I N I S H I N G   P R O P E R T Y   V A L U E S
export function loadFinishingPropertyValues() {
    return {
        type: DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES,
    };
}

export function loadFinishingPropertyValuesRes(data) {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES, 'res'),
        data,
    };
}

export function loadFinishingPropertyValuesErr() {
    return {
        type: actionCreator(DesignLibraryTypes.LOAD_FINISHING_PROPERTY_VALUES, 'err'),
    };
}
// L O A D   F I N I S H I N G   P R O P E R T Y   V A L U E S
